import abstractModel from '../../core/ShopModel';

const resource = 'pipedream';

const model = abstractModel(resource);
model.syncProducts = (params = {}) => model.save(params, { path: `${resource}/sync_products` });

export default model;
